/**
 * Costs & Margin Hub tab — gated by FF_COSTS_MARGIN_TAB via /api/config.
 * Separate from JOBCOST_ENABLED (varshyl-jobcost iframe).
 */

export type CostsMarginConfig = {
  costsMarginTabEnabled?: boolean
}

export function isCostsMarginTabEnabled(
  config: CostsMarginConfig | null | undefined,
): boolean {
  return config?.costsMarginTabEnabled === true
}
